import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AuthProvider } from "./context/AuthContext";
import { Provider } from "react-redux";
import store from "./store";

// Validate required environment variables
const googleClientId = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;
if (!googleClientId) {
  throw new Error(
    'REACT_APP_GOOGLE_OAUTH_CLIENT_ID is required but not set. ' +
    'Please add it to your .env file.'
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <GoogleOAuthProvider clientId={googleClientId}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </GoogleOAuthProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
